export default __webpack_public_path__ + "static/MessinaSansWeb-Book-3c2df4b41db18ba6d7c3f4c05a84575b.woff2";